/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DoctoresPacientesControllerBorrarPaciente$Params {

/**
 * UUID del paciente a borrar
 */
  uuidPaciente: string;
}

export function doctoresPacientesControllerBorrarPaciente(http: HttpClient, rootUrl: string, params: DoctoresPacientesControllerBorrarPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, doctoresPacientesControllerBorrarPaciente.PATH, 'delete');
  if (params) {
    rb.path('uuidPaciente', params.uuidPaciente, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

doctoresPacientesControllerBorrarPaciente.PATH = '/api/doctor-pacientes/borrar-paciente/{uuidPaciente}';
